declare var window: Window & {
  devToolsExtension: any;
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
};

import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
import thunk from "redux-thunk";

import { RootState } from "./types";
import rootReducer from "./reducer";
import http from "../helpers/http";
import { enhancer as wizardEnhancer } from "../routes/Wizard";
import { enhancer as authEnhancer } from "../routes/Auth";

export const history = createHistory();

const initState = {} as RootState;
const enhancers = [authEnhancer, wizardEnhancer];
const middleware = [thunk.withExtraArgument(http), routerMiddleware(history)];

const composeEnhancers =
  process.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

const store = createStore(
  rootReducer,
  initState,
  composeEnhancers(applyMiddleware(...middleware), ...enhancers),
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.ts